export const en = {
    'client-id': 'ClientID',
    'full-name': 'Name',
    login: 'Username',
    products: 'List of managed products'
};
